module.exports = __webpack_public_path__ + "img/icon23.22f8b29f.png";